export default class address {
  constructor() {
    this.streetAddress1 = '';
    this.streetAddress2 = '';
    this.zipCode = '';
    this.city = '';
    this.state = '';
    this.country = '';
  }
}



// WEBPACK FOOTER //
// ./src/entities/address.js